export default "__VITE_ASSET__BOADeSB5__"